module.exports = __webpack_public_path__ + "img/Speaker=Serena McDonnell.57f1fb36.png";